var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{attrs:{"id":"nav"}},[_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/pics"}},[_vm._v("Pictures")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/cook"}},[_vm._v("Cooking")])],1)]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08c2df5f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 13
// module chunks = 0